<!-- the strip has pointer-events: none, so it can carry no handlers of its own -- only the
     scroll bar inside it can be touched or clicked -->
<div #scrollBarHoverArea class="scrollbar-hover-detection-area" [hidden]="disableScrollbar">
     <div #scrollBar class="scrollbar" (mousedown)="onMouseDown($event)" (touchstart)="onTouchStart($event)"></div>
</div>
<div #scrollArea [ngClass]="scrollAreaClass" class="cs-scrollable-area">
     <ng-content></ng-content>
</div>